import { useState } from "react";
import { Col, Row } from "react-bootstrap";
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";

const IMAGE_EXTS = /\.(jpg|jpeg|png|gif|webp|bmp|svg|avif|heic)$/i;

const getImageExt = (url) => {
  try {
    const path = new URL(url).pathname;
    const match = path.match(IMAGE_EXTS);
    return match ? match[0].toLowerCase() : ".jpg";
  } catch {
    return ".jpg";
  }
};

const buildFilename = (url, filename) => {
  const base = filename && filename.trim() && filename !== "image"
    ? filename.trim()
    : "image";
  return IMAGE_EXTS.test(base) ? base : base + getImageExt(url);
};

const downloadImage = async (url, filename) => {
  const finalName = buildFilename(url, filename);
  try {
    const origin = window.location.protocol + "//" + window.location.host;
    const proxyUrl = `${origin}/api/download-file?url=${encodeURIComponent(url)}&filename=${encodeURIComponent(finalName)}`;
    const response = await fetch(proxyUrl, {
      headers: { "x-auth-token": localStorage.getItem("x-auth-token") || "" },
    });
    if (!response.ok) throw new Error("proxy failed");
    const blob = await response.blob();
    const blobUrl = window.URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = blobUrl;
    a.download = finalName;
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    window.URL.revokeObjectURL(blobUrl);
  } catch {
    window.open(url, "_blank");
  }
};

function ShowImage({ img, images, width, alt, onLoad }) {
  const [show, setShow] = useState(false);
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  const primaryUrl = images ? images?.[0]?.cloudUrl : img;
  const primaryFilename = images ? (images?.[0]?.fileName || "image") : (alt || "image");

  return (
    <>
      <div className="chat-img-wrapper">
        <img
          className={width}
          src={primaryUrl}
          alt={alt}
          onClick={handleShow}
          onLoad={onLoad}
        />
        <button
          className="chat-img-download-btn"
          onClick={(e) => { e.stopPropagation(); downloadImage(primaryUrl, primaryFilename); }}
          title="Download"
          aria-label="Download image"
        >
          <i className="bi bi-download"></i>
        </button>
      </div>
      <Modal size="lg" show={show} onHide={handleClose}>
        <Modal.Header closeButton>
          <Modal.Title>View Image</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Row>
            <Col>
              {images
                ? images?.map((item, index) => (
                    <img key={index} src={item?.cloudUrl} alt={item?.fileName} className="width" />
                  ))
                : <img src={img} alt={alt} className="w-100" />
              }
            </Col>
          </Row>
        </Modal.Body>
        <Modal.Footer>
          {images
            ? images?.map((item, index) => (
                <Button
                  key={index}
                  variant="success"
                  className="me-2"
                  onClick={() => downloadImage(item?.cloudUrl, item?.fileName || "image")}
                >
                  <i className="bi bi-download me-1"></i>
                  {images.length > 1 ? `Download ${index + 1}` : "Download"}
                </Button>
              ))
            : (
              <Button variant="success" onClick={() => downloadImage(img, alt || "image")}>
                <i className="bi bi-download me-1"></i>Download
              </Button>
            )
          }
          <Button variant="danger" onClick={handleClose}>
            Close
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
}

export default ShowImage;
